import { httpClient } from "./httpClient";

const getAllProject = () => {
  return httpClient.get("dataProject");
};

export default {
  getAllProject,
};
